export class CsvBuilder {
    private rows: Array<Array<string | undefined>> = [];

    public addRow(data: Array<string | undefined>): void {
        this.rows.push(data);
    }

    public reset(): void {
        this.rows = [];
    }

    public toBlob(): Blob {
        let result = '';
        for (const row of this.rows) {
            result += row
                .map((value) => {
                    if (!value) {
                        return '';
                    }

                    if (!/[,"]/.exec(value)) {
                        return value;
                    }

                    return `"${value.replaceAll('"', '""')}"`;
                })
                .join(',');
            result += '\n';
        }

        return new Blob([result], { type: 'text/csv' });
    }
}
